// extracted by mini-css-extract-plugin
module.exports = {"numberInput":"formInputDistance_numberInput__xiLXz"};